import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as Input } from './Input.vue';

export const inputVariants = cva(
	'flex w-full items-center rounded-[2px] border border-white-dark-4 bg-transparent text-sm text-primary transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:border-primary focus:outline-none focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:bg-white-dark-2 disabled:border-white-dark-3 disabled:text-black/40',
	{
		variants: {
			variant: {
				default: 'h-9 self-stretch px-4 py-1',
				insideLabel:
					'peer h-[50px] px-4 pb-1 pt-5 leading-[150%] placeholder-transparent'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export const inputContainerVariants = cva('w-full', {
	variants: {
		variant: {
			default: '',
			insideLabel: 'relative'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export interface InputProps {
	defaultValue?: string | number;
	modelValue?: string | number | null;
	error?: boolean | string;
	class?: HTMLAttributes['class'];
	placeholder?: HTMLAttributes['placeholder'];
	labelClass?: HTMLAttributes['class'];
	variant?: 'default' | 'insideLabel';
	autofocus?: boolean;
	/** Cypress test identifier for selecting this input element in tests */
	cyTestId?: string;
	/** Whether the input is disabled */
	disabled?: boolean;
}
